<template>
   <v-container>
      <v-toolbar dense color="primary white--text" bottom class="mx-2">
         <v-toolbar-title>
            <v-icon left color="white">mdi-check-decagram</v-icon>
            Student Profile Update
         </v-toolbar-title>
      </v-toolbar>
      <v-row class="px-2">
         <v-col cols="12" md="12">
            <v-card outlined>
               <v-card-title v-if="$globalstore">
                  {{ currentyeartermtext }}
               </v-card-title>
               <v-card-text>
                  To ensure that the student's current information is up to date, you will be
                  reminded to update the information every 90 days.
               </v-card-text>
            </v-card>
         </v-col>
      </v-row>
      <v-row class="pt-3 px-3">
         <v-col cols="12" md="12">
            <v-data-table
               dense
               :items="childrenlist"
               :headers="studentheaders"
               @click:row="studentRowClick"
               item-key="school_id"
               hide-default-footer
               single-select
               :item-class="formNeedUpdate"
            >
               <!-- eslint-disable-next-line -->
               <template v-slot:item.profile_complete="{item}">
                  {{ getProfileStatus(item) }}
               </template>
               <!-- eslint-disable-next-line -->
               <template v-slot:item.actions="{item}">
                  <v-icon small class="mr-2" @click="editProfile(item)">
                     mdi-pencil
                  </v-icon>
               </template>
            </v-data-table>
         </v-col>
      </v-row>
      <!-- Dialog for consent form -->
      <v-dialog v-model="modal" persistent width="500px" height="65vh" @keydown.esc="modal = false">
         <v-card outlined>
            <v-row no-gutters>
               <v-col cols="12">
                  <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                     <v-toolbar-title>Profile Form</v-toolbar-title>
                     <v-spacer></v-spacer>
                     <v-btn @click="cancelEditProfile" class="mx-2">Cancel</v-btn>
                     <v-btn @click="updateProfile" class="mx-2">Save</v-btn>
                  </v-toolbar>
               </v-col>
            </v-row>
         </v-card>
         <v-card height="60vh" class="overflow-y-auto">
            <v-row no-gutters class="px-5">
               <v-col cols="12" md="12"
                  ><strong>Profile Form for {{ selectedStudentName }}</strong>
               </v-col>
            </v-row>
            <v-row no-gutters class="pt-3 px-5">
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Mother's / Guardian's contact number"
                     v-model="edit_mother_contactnumber"
                     clearable
                  ></v-text-field>
               </v-col>
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Father's / Guardian's contact number"
                     v-model="edit_father_contactnumber"
                     clearable
                  ></v-text-field>
               </v-col>
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Student's mobile Number"
                     v-model="edit_student_mobilenumber"
                     clearable
                  ></v-text-field>
               </v-col>
            </v-row>
            <v-row no-gutters class="px-5">
               <div>
                  <u>Alternative contact (in the event parent / guardian cannot be reached)</u>
               </div>
            </v-row>
            <v-row no-gutters class="pt-3 px-5">
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Contact Name"
                     v-model="edit_alt_contactname"
                     clearable
                  ></v-text-field>
               </v-col>
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Relationship to student"
                     v-model="edit_alt_relationship"
                     clearable
                  ></v-text-field>
               </v-col>
               <v-col cols="12" md="12">
                  <v-text-field
                     dense
                     label="Contact number"
                     v-model="edit_alt_contactnumber"
                     clearable
                  ></v-text-field>
               </v-col>
            </v-row>
            <v-row no-gutters class="px-5">
               <v-col cols="12" md="12">
                  <div>
                     My child is able to swim 25 metres unaided:
                     <v-radio-group v-model="edit_swim_unaided" row>
                        <v-radio label="No" :value="0"></v-radio>
                        <v-radio label="Yes" :value="1"></v-radio>
                     </v-radio-group>
                  </div>
               </v-col>
               <v-col cols="12" md="12">
                  <div>
                     My child has the following food allergies (if no allergies, please type N/A):
                     <v-text-field
                        class="pt-2"
                        dense
                        label="Food allergies"
                        v-model="edit_food_allergy"
                        clearable
                     ></v-text-field>
                  </div>
               </v-col>
               <v-col cols="12" md="12">
                  My child has the following medication allergies (if no allergies, please type
                  N/A):
                  <v-text-field
                     class="pt-2"
                     dense
                     label="Medication allergies"
                     v-model="edit_medical_allergy"
                     clearable
                  ></v-text-field>
               </v-col>
            </v-row>
            <v-row no-gutters class="px-2">
               <v-textarea
                  class="pa-2"
                  v-model="edit_remarks"
                  outlined
                  no-resize
                  rows="4"
                  label="Any other special instruction/information"
                  counter="1024"
                  clearable
               >
               </v-textarea>
            </v-row>
         </v-card>
      </v-dialog>
      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {ConfirmDlg, ShowToast},

      data() {
         return {
            parentlink: null,
            childrenlist: [],
            modal: false,
            currentyeartermtext: "",

            selectedStudentName: "",
            selectedSchoolID: "",
            edit_mother_contactnumber: "",
            edit_father_contactnumber: "",
            edit_student_mobilenumber: "",
            edit_alt_contactname: "",
            edit_alt_relationship: "",
            edit_alt_contactnumber: "",
            edit_swim_unaided: 0,
            edit_food_allergy: "",
            edit_medical_allergy: "",
            edit_remarks: "",

            studentheaders: [
               {
                  text: "Student",
                  value: "student_fullname",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Year",
                  value: "yeargrouptext",
                  class: this.$globalstore.table_smallheaderclass,
               },

               {
                  text: "Profile Form",
                  value: "profile_complete",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Last Update",
                  value: "last_update",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Update By",
                  value: "update_by",
                  class: this.$globalstore.table_smallheaderclass,
                  width: "25%",
               },
               {
                  text: "Edit",
                  value: "actions",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },

      methods: {
         studentRowClick(item, row) {
            row.select(!row.isSelected);
         },

         formNeedUpdate(item) {
            return item.profile_needupdate ? "needattention" : "";
         },

         getProfileStatus(item) {
            if (!item.profile_complete) {
               return "Incomplete";
            } else if (item.profile_needupdate) {
               return "Need Update";
            } else {
               return "Complete";
            }
         },

         async loadChildrenProfileData() {
            if (this.parentlink) {
               await this.$http({
                  url: "/cca/getchildprofile.php",
                  headers: {"Content-Type": "application/x-www-form-urlencoded"},
                  data: {
                     contact_id: this.parentlink,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.childrenlist = response.data.profiledata;
                     }
                  }
               });
            }
         },

         editProfile(item) {
            this.selectedStudentName = item.student_fullname;
            this.selectedSchoolID = item.school_id;

            this.edit_mother_contactnumber = item.mother_contactnumber;
            this.edit_father_contactnumber = item.father_contactnumber;
            this.edit_student_mobilenumber = item.student_mobilenumber;
            this.edit_alt_contactname = item.alt_contactname;
            this.edit_alt_relationship = item.alt_relationship;
            this.edit_alt_contactnumber = item.alt_contactnumber;
            this.edit_swim_unaided = item.swim_unaided;
            this.edit_food_allergy = item.food_allergy;
            this.edit_medical_allergy = item.medical_allergy;
            this.edit_remarks = item.remarks;

            this.modal = true;
         },

         cancelEditProfile() {
            this.resetFormFields();
            this.modal = false;
         },

         resetFormFields() {
            this.selectedStudentName = "";
            this.selectedSchoolID = "";
            this.edit_mother_contactnumber = "";
            this.edit_father_contactnumber = "";
            this.edit_student_mobilenumber = "";
            this.edit_alt_contactname = "";
            this.edit_alt_relationship = "";
            this.edit_alt_contactnumber = "";
            this.edit_swim_unaided = 0;
            this.edit_food_allergy = "";
            this.edit_medical_allergy = "";
            this.edit_remarks = "";
         },

         updateProfile() {
            this.modal = false;
            this.doUpdateProfile();
         },

         async doUpdateProfile() {
            await this.$http({
               url: "/cca/updatechildrenprofile.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  child_profile: {
                     school_id: this.selectedSchoolID,
                     mother_contactnumber: this.edit_mother_contactnumber,
                     father_contactnumber: this.edit_father_contactnumber,
                     student_mobilenumber: this.edit_student_mobilenumber,
                     alt_contactname: this.edit_alt_contactname,
                     alt_relationship: this.edit_alt_relationship,
                     alt_contactnumber: this.edit_alt_contactnumber,
                     swim_unaided: this.edit_swim_unaided,
                     food_allergy: this.edit_food_allergy,
                     medical_allergy: this.edit_medical_allergy,
                     remarks: this.edit_remarks,
                  },
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.loadChildrenProfileData();
                     this.resetFormFields();
                  }
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.parentlink = this.$globalstore.user.userlinkid;
            this.currentyeartermtext = this.$globalstore.appsettings.currentyearterm.termyeartext;
            await this.loadChildrenProfileData();
         }
      },
   };
</script>
